/** PageHeading: the page title (with an optional emoji that waves once), a subtitle and controls on the right. */
import type { ReactNode } from "react";

interface PageHeadingProps {
  title: string;
  emoji?: string;
  subtitle?: string;
  /** Right-side controls. */
  children?: ReactNode;
}

export function PageHeading({ title, emoji, subtitle, children }: PageHeadingProps) {
  return (
    <div className="flex w-full flex-wrap items-start justify-between gap-4">
      <div className="flex animate-rise flex-col items-start gap-3 leading-none">
        <h1 className="flex min-h-[34px] items-center gap-[0.25em] whitespace-nowrap text-display font-medium text-foreground">
          {title}
          {emoji && (
            <span aria-hidden className="inline-block origin-[70%_70%] animate-wave">
              {emoji}
            </span>
          )}
        </h1>
        {subtitle && <p className="text-body text-secondary-foreground">{subtitle}</p>}
      </div>
      {children && <div className="flex animate-rise items-start gap-2">{children}</div>}
    </div>
  );
}
